import { gql } from '@apollo/client';

export const REFRESH_LEGACY_TOKEN = gql`
  mutation RefreshLegacyToken($token: String!) {
    refreshLegacyToken(token: $token) {
      userId
      accessToken
      refreshToken
    }
  }
`;
